import axios from 'axios';

const api = axios.create({
    baseURL: 'https://app.alindustria.com.br:4000/',
    timeout: 180000
  });

export default api;